import React from 'react';
import Select from 'react-select';
import { dashboardSearchableInput, ghostSelectInput } from '../../utils/customSelectStyle';
// import '../../sass/custom_styles/custom_styles.scss';

const resolveSelectInputStyle = (customStyles, isSearchable) => {
  if (customStyles?.input
    && customStyles.input !== ghostSelectInput
    && customStyles.input !== dashboardSearchableInput) {
    return customStyles.input;
  }
  return isSearchable ? dashboardSearchableInput : ghostSelectInput;
};

const defaultClassNames = (isSearchable) => ({
  control: () => 'select_control',
  menu: () => 'select_menu',
  menuList: () => 'select_menu_list',
  option: () => 'select_option',
  singleValue: () => 'select_single_value',
  placeholder: () => 'select_placeholder',
  valueContainer: () => 'select_value_container',
  input: () => (isSearchable ? 'select_input select_input--searchable' : 'select_input'),
  multiValue: () => 'select_multi_value',
  multiValueLabel: () => 'select_multi_value_label',
  multiValueRemove: () => 'select_multi_value_remove',
});

const mergeClassNames = (isSearchable, customClassNames) => {
  if (!customClassNames) {
    return defaultClassNames(isSearchable);
  }

  return {
    ...customClassNames,
    input: (state) => {
      const base = typeof customClassNames.input === 'function'
        ? customClassNames.input(state)
        : (customClassNames.input ?? 'select_input');
      return isSearchable ? `${base} select_input--searchable` : base;
    },
  };
};

const CustomSelect = ({
  placeholder,
  isSearchable = false,
  styles: customStyles,
  classNames: customClassNames,
  ...props
}) => (
  <Select
    placeholder={placeholder}
    isSearchable={isSearchable}
    classNames={mergeClassNames(isSearchable, customClassNames)}
    styles={{
      ...customStyles,
      input: resolveSelectInputStyle(customStyles, isSearchable),
    }}
    {...props}
  />
);

export default CustomSelect;
